"use client";
import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons/button-base";
import {assetPath} from "@/shared/utils/asset-path";

import type {DestinationListRenderProps} from "../destination-list";

export function ShowMoreButton({actions, hasMore}: DestinationListRenderProps): JSX.Element {
    const {t} = useTranslation("common");
    return (
        <ButtonBase variant="secondary-outline" onClick={actions.handleShowMore} size="sm" width="fit" className="destination__button-show-more">
            {hasMore ? t("showMore") : t("showLess")}
            <SmartImage
                src={assetPath("/images/icons/arrow-black-down.svg")}
                alt="Arrow"
                width={12}
                height={10}
                className={`destination__arrow ${!hasMore ? "destination__arrow--up" : ""}`}
            />
        </ButtonBase>
    );
}
